import { defineMessages } from 'react-intl'

export default defineMessages({
    resumeHeading: {
        id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.components.OrderHoldModal.heading.resume',
        defaultMessage: 'Resume tasks',
    },
    holdHeading: {
        id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.components.OrderHoldModal.heading.hold',
        defaultMessage: 'Hold tasks',
    },
    holdMessageHeading: {
        id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.components.OrderHoldModal.holdMessageHeading',
        defaultMessage: 'Hold Message',
    },
    holdMessageDescription: {
        id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.components.OrderHoldModal.holdMessageDescription',
        defaultMessage: 'This message will be sent to the suppliers of the tasks that are placed on hold.',
    },
    resumeMessageHeading: {
        id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.components.OrderHoldModal.resumeMessageHeading',
        defaultMessage: 'Resume Message',
    },
    resumeMessageDescription: {
        id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.components.OrderHoldModal.resumeMessageDescription',
        defaultMessage: 'This message will be sent to the suppliers of the tasks that are resumed.',
    },
    defaultHoldMessage: {
        id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.components.OrderHoldModal.defaultHoldMessage',
        defaultMessage: 'Hi {supplierFirstName}\n\nDue to certain circumstances, we have to put this order on hold - Please stop the recordings.\nWe will get back to you when we are ready to proceed.\nSorry for any inconvenience.\n\nBest regards,\n{coordinatorName}\n\n{taskUrl}',
    },
    defaultResumeMessage: {
        id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.components.OrderHoldModal.defaultResumeMessage',
        defaultMessage: 'Hi {supplierFirstName}\n\nWe are glad to inform you that we are now ready to proceed with this order.Please proceed with the recordings - note that there might have been changes in the brief or the script, so please record the updated script and read the brief again.\nHave fun recording.\n\nBest regards,\n{coordinatorName}\n\n{taskUrl}',
    },
    holdButton: {
        id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.components.OrderHoldModal.holdButton',
        defaultMessage: 'Hold Tasks',
    },
    resumeButton: {
        id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.components.OrderHoldModal.resumeButton',
        defaultMessage: 'Resume Tasks',
    },
})
